import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const ChevronRight = ({ title = 'Forward', ...rest }: IconProps) => (
  <BaseSvg viewBox="0 0 12 12" title={title} {...rest}>
    <path
      d="M4.781.375a1,1,0,0,0-1.562,1.25L6.719,6l-3.5,4.375a1,1,0,0,0,1.562,1.25l4-5a1,1,0,0,0,0-1.25Z"
      fill="currentColor"
    ></path>
  </BaseSvg>
)

ChevronRight.displayName = 'ChevronRight'
export default ChevronRight
